// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__YrdBs","content":"GlobalSearch_content__1MeHc"};